import { IApplicationState } from '../../types/redux';

export const selectPopupOpener = (state: IApplicationState) => {
  return state.callbackPopup.opener;
};
